<template>
  <el-container>
    <el-header class="header">
      <HeaderComponent></HeaderComponent>
    </el-header>
    <el-container>
      <SideBarComponent></SideBarComponent>
      <el-main class="main workblank">
        <SubTitleComponent v-if="global.type == 'client'" :title="title"></SubTitleComponent>
        <div class="box">
          <el-row :gutter="10" v-if="global.type == 'manage'" class="tool">
            <el-col :span="3">
              <h4>我的客户</h4>
            </el-col>
            <el-col :span="12">
              <el-select v-model="customerValue" placeholder="请选择" @change="customerChange">
                <el-option
                  v-for="item in customerData"
                  :key="item.number"
                  :label="item.number + item.client_name"
                  :value="item.client_name">
                </el-option>
              </el-select>
            </el-col>
          </el-row>
          <h4 v-if="global.type == 'client'">上传毛坯图/手绘图</h4>
          <div class="prompt">可以前往AI改图消除底图中的障碍物！</div>
          <ul class="list">
            <li v-for="(item, index) in workblankData" :key="'workblank' + index" class="item" ref="workblankItem">
              <div class="img_box" :data-count="item.workblank.length < 9 ? item.workblank.length + 1 : item.workblank.length">
                <div class="img_item" v-for="(itemS, indexS) in item.workblank" :key="'img' + itemS.workblank_id">
                  <img :src="itemS.photo_url" alt="" @click="toDetail(index,indexS)">
                  <i class="el-icon-error" @click="toDetaleW(index, indexS)"></i>
                </div>
                <el-upload
                  v-if="item.workblank.length < 9"
                  class="upload-demo"
                  action=""
                  :show-file-list="false"
                  multiple
                  :data="{'space_cur': index}"
                  :http-request="handleDetail">
                  <el-button class="" icon="el-icon-plus"></el-button>
                </el-upload>
              </div>
              <div class="name">{{ item.space_type }}</div>
              <i v-if="item.workblank_space_id != 0" class="el-icon-error" @click="toDetaleS(index)"></i>
            </li>
            <li>
              <el-button class="add" :style="'height:'+workblankItemHeight+'px'" icon="el-icon-plus" @click="dialogFormVisible = true">新建功能区</el-button>
            </li>
          </ul>
          <el-row :gutter="10" class="btn_row">
            <el-col :span="12" :offset="6">
              <el-button class="" type="success" @click="toPath">生成效果图</el-button>
            </el-col>
          </el-row>
        </div>
        <el-dialog title="新增功能区" :visible.sync="dialogFormVisible" center>
          <el-form>
            <el-form-item>
              <el-input v-model="workblankName" autocomplete="off" placeholder="请输入功能区名称"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible = false">取 消</el-button>
            <el-button type="success" @click="toAddS">确 定</el-button>
          </div>
        </el-dialog>
        <el-dialog
          custom-class="pop_img"
          v-if="dialogVisible == 'detail'"
          :visible.sync="dialogVisit"
          top="15vh"
          :show-close="false"
          :center="true"
          :closeDetail="closeDetail">
          <div class="img" v-if="dialogImg != ''">
            <img :src="dialogImg" alt="">
          </div>
        </el-dialog>
      </el-main>
    </el-container>
  </el-container>
</template>
  
<script>

let _ajaxType = 0

export default {
  name: 'Workblank',
  components: {},
  data() {
    return {
      title: '上传毛坯图/手绘图',
      id: 0,
      customerData: [],
      customerValue: '',
      workblankData: [],
      page: 0,
      pagesize: 20,
      allpage: 0,
      sessionId: localStorage.getItem('sessionId'),
      workblankName: '',
      dialogFormVisible: false,
      dialogVisible: '',
      dialogVisit: false,
      dialogImg: '',
      workblankItemHeight: 0
    }
  },
  mounted() {
    let _title = '上传毛坯图/手绘图'
    if(this.global.type == 'client'){
      _title = this.global.clientName
    }
    this.title = _title
    this.getCustomer()
  },
  methods: {
    toDetail(cur, curS) {
      this.dialogImg = this.workblankData[cur].workblank[curS].photo_url
      this.dialogVisit = true
      this.dialogVisible = 'detail'
    },
    closeDetail(e) {
      this.dialogImg = ''
      this.dialogVisit = false
      this.dialogVisible = ''
      e()
    },
    customerChange(e) {
      console.log('customerChange', e)
      let nowCustomer = this.customerData.find(c => c.client_name === e);
      this.global.clientId = nowCustomer.client_id
      this.global.clientName = nowCustomer.client_name
      this.page = 0
      this.allpage = 0
      this.workblankData = []
      this.getData()
    },
    handleDetail(image) {
      console.log("1", image);
      if(_ajaxType == 1) return
      _ajaxType = 1
      return new Promise((resolve, reject) => {
        // console.log('2',image.file)
        const isImage = image.file.type.startsWith('image/');
        if (!isImage) {
          this.uploadError = '只能上传图片文件';
          _ajaxType = 0
          reject(new Error('只能上传图片文件'));
          return;
        }

        const reader = new FileReader();
        reader.onload = (e) => {
          console.log('upload',e)
          const base64Data = e.target.result;
          this.toUpload(base64Data,image.data.space_cur);
          resolve(false); // 阻止默认上传行为
        };
        reader.onerror = (error) => {
          console.error('读取文件失败:', error);
          this.uploadError = '读取文件失败，请重试';
          reject(error);
        };
        reader.readAsDataURL(image.file);
      });
    },
    getCustomer() {
      let _url = "/api/?mod=client&action=all"
      this.axios.post(_url).then(json => {
        // 获取
        _ajaxType = 0
        let _data = json.data.data
        console.log("customerData", _data);
        if (json.data.errcode == 0) {
          let _client = _data.result[0].client_name
          if(this.global.type == 'manage' && this.global.clientName != ''){
            _client = this.global.clientName
          }
          this.customerValue = _client
          this.customerData = _data.result
          this.getData()
        }
        console.log(json.data);
      })
    },
    getData() {
      if(_ajaxType == 1) return
      let _page = this.page
      let _allpage = this.allpage
      console.log(_page, _allpage)
      if(_allpage <= 0 || _page < _allpage){
        _ajaxType = 1
        let nowCustomer = this.customerData.find(c => c.client_name === this.customerValue);
        let _id = nowCustomer.client_id
        if(this.global.type == 'client'){
          _id = this.global.clientId
        }
        console.log('nowCustomer', nowCustomer, _id)
        let _url = "/api/?mod=workblank"
        let _workblankData = {
          page: _page + 1,
          pagesize: this.pagesize,
          client_id: _id
        }
        // console.log(this.axios)
        this.axios.post(_url, _workblankData).then(json => {
          // 获取
          _ajaxType = 0
          let _data = json.data.data
          console.log("workblankData", _data);
          if (json.data.errcode == 0) {
            this.page = _data.page
            this.allpage = _data.allpage
            this.workblankData = [...this.workblankData, ..._data.result]
            this.materialItemHeight = 0
            setTimeout(this.getHeight, 500)
          }
          console.log(json.data);
        })
      }else(
        _ajaxType = 0
      )
    },
    getHeight() {
      let _workblank = this.workblankData
      // if(_workblank.length <= 0) return
      let _workblankItem = this.$refs.workblankItem[0]
      console.log('height', _workblankItem.offsetHeight)
      // let _row = _workblank.length > 5 ? 2 : 1
      this.workblankItemHeight = _workblankItem.offsetHeight
    },
    toUpload(base64Data,cur) {
      let _url = "/api/?mod=upload"
      let _uploadData = {
        photo: base64Data
      }
      console.log(_uploadData)
      this.axios.post(_url, _uploadData).then(json => {
        // 获取
        // _ajaxType = 0
        let _data = json.data.data
        console.log("uploadData", _data);
        if (json.data.errcode == 0) {
          let _addUrl = "/api/?mod=workblank&action=save"
          let nowCustomer = this.customerData.find(c => c.client_name === this.customerValue);
          let _id = nowCustomer.client_id
          let _space = this.workblankData[cur].space_type
          let _addData = {
            photo_url: _data.photo_url,
            client_id: _id,
            space_type: _space
          }
          this.axios.post(_addUrl, _addData).then(json => {
            // 获取
            _ajaxType = 0
            let _addData = json.data.data
            console.log("addData", _addData);
            if (json.data.errcode == 0) {
              let _workblank = [...this.workblankData]
              _workblank[cur].workblank.push({
                photo_url: _data.photo_url,
                workblank_id: _addData.workblank_id
              })
              this.workblankData = _workblank
              this.$message({
                message: '上传成功',
                type: 'success',
                offset: 300,
                onClose: function() {
                }
              });
            }
            console.log(json.data);
          })
          // this.$message({
          //   message: '上传成功',
          //   type: 'success',
          //   offset: 300,
          //   onClose: function() {
          //   }
          // });
        }
        console.log(json.data);
      })
    },
    handleChange(value) {
      // this.selectedOptions = value;
      console.log(value)
      console.log(this.form)
    },
    toAddS() {
      if(_ajaxType == 1) return
      _ajaxType = 1
      let _url = "/api/?mod=workblank_space&action=save"
      let nowCustomer = this.customerData.find(c => c.client_name === this.customerValue);
      let _id = nowCustomer.client_id
      let _workblankName = this.workblankName
      let _addData = {
        client_id: _id,
        space_type: _workblankName
      }
      this.axios.post(_url, _addData).then(json => {
        // 获取
        _ajaxType = 0
        let _data = json.data.data
        console.log("addData", _data);
        if (json.data.errcode == 0) {
          let _workblank = [...this.workblankData]
          _workblank.push({
            space_type: _workblankName,
            workblank_space_id: _data.workblank_space_id,
            workblank: []
          })
          this.workblankData = _workblank
          this.dialogFormVisible = false
          this.workblankName = ''
          this.$message({
            message: '添加成功',
            type: 'success',
            offset: 300,
            onClose: function() {
            }
          });
        }
        console.log(json.data);
      })
    },
    toDetaleW(cur, curs){
      if(_ajaxType == 1) return
      _ajaxType = 1
      this.$confirm('此操作将删除该底图, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let _url = "/api/?mod=workblank&action=delete"
        let nowCustomer = this.customerData.find(c => c.client_name === this.customerValue);
        let _id = nowCustomer.client_id
        let _workblankData = this.workblankData
        let _deleteData = {
          client_id: _id,
          workblank_id: _workblankData[cur].workblank[curs].workblank_id
        }
        this.axios.post(_url, _deleteData).then(json => {
          // 获取
          _ajaxType = 0
          let _data = json.data.data
          console.log("deleteData", _data);
          if (json.data.errcode == 0) {
            let _workblank = [...this.workblankData]
            _workblank[cur].workblank.splice(curs, 1)
            this.workblankData = _workblank
            this.$message({
              message: '删除成功',
              type: 'success',
              offset: 300,
              onClose: function() {
              }
            });
          }
          console.log(json.data);
        })
      }).catch(() => {
        _ajaxType = 0 
      });
    },
    toDetaleS(cur){
      if(_ajaxType == 1) return
      _ajaxType = 1
      this.$confirm('此操作将删除该功能区, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let _url = "/api/?mod=workblank_space&action=delete"
        let nowCustomer = this.customerData.find(c => c.client_name === this.customerValue);
        let _id = nowCustomer.client_id
        let _workblankData = this.workblankData
        let _deleteData = {
          client_id: _id,
          workblank_space_id: _workblankData[cur].workblank_space_id
        }
        this.axios.post(_url, _deleteData).then(json => {
          // 获取
          _ajaxType = 0
          let _data = json.data.data
          console.log("deleteData", _data);
          if (json.data.errcode == 0) {
            let _workblank = [...this.workblankData]
            _workblank.splice(cur, 1)
            this.workblankData = _workblank
            this.$message({
              message: '删除成功',
              type: 'success',
              offset: 300,
              onClose: function() {
              }
            });
          }
          console.log(json.data);
        })
      }).catch(() => {
        _ajaxType = 0 
      });
    },
    toPath() {
      this.$router.push('/effectsave')
    }
  }
}
</script>
  
<style scoped lang="less">
.header {
  z-index: 1001;
}
.main {
  padding-top: 10px;
  padding-left: 8px;
  padding-right: 8px;
  padding-bottom: 6px;
  .box {
    min-height: calc(100vh - 154px);
    padding: 20px;
    background: #f8f8f8;
    box-sizing: border-box;
    .tool {
      background: #fff;
      h4 {
        // margin-bottom: 8px;
        // padding-left: 12px;
        color: rgb(16, 16, 16);
        font-size: 20px;
        font-weight: 400;
        line-height: 2em;
      }
    }
    .prompt {
      display: inline-block;
      margin-top: 10px;
      padding-left: 35px;
      background: url(../assets/ico_prompt.png) no-repeat;
      background-size: 20px 20px;
      background-position: 10px center;
      background-color: #f4f7f3;
      border: 1px solid #bbb;
      border-radius: 4px;
      font-size: 14px;
      line-height: 30px;
    }
    ul.list {
      display: grid;
      // flex-wrap: wrap;
      // justify-content: space-between;
      grid-template-columns: repeat(4, 1fr);
      padding-inline-start: 0;
      gap: 20px;
      // padding: 0 30px;
      margin-top: 10px;
      vertical-align: top;
      list-style: none;
      li {
        position: relative;
        // flex: 0 0 calc(30%);
        // padding: 10px;
        background: #fff;
        border: 1px solid rgb(187, 187, 187);
        border-radius: 2px;
        box-sizing: border-box;
        font-size: 0;
        .name {
          // margin-top: 8px;
          background-color: #f4f7f3;
          font-size: 16px;
          line-height: 30px;
          text-align: center;
        }
        .img_box {
          display: grid;
          gap: 10px;
          width: 100%;
          padding: 10px;
          box-sizing: border-box;
          aspect-ratio: 1 / 1; /* 宽高比为 1:1 */
          .img_item {
            position: relative;
            img {
              width: 100%;
              aspect-ratio: 1 / 1; /* 宽高比为 1:1 */
              object-fit: cover;
            }
          }
          /* 1张图片时的布局 */
          &[data-count="1"]{
            grid-template-columns: 1fr;
            grid-template-rows: 1fr;
          }
          /* 2-4张图片时的布局 */
          &[data-count="2"],
          &[data-count="3"],
          &[data-count="4"] {
            grid-template-columns: repeat(2, 1fr);
            grid-template-rows: repeat(2, 1fr);
          }
          /* 5-9张图片时的布局 */
          &[data-count="5"],
          &[data-count="6"],
          &[data-count="7"],
          &[data-count="8"],
          &[data-count="9"] {
            grid-template-columns: repeat(3, 1fr);
            grid-template-rows: repeat(3, 1fr);
          }
        }
        .el-button {
          width: 100%;
          padding: 0;
          aspect-ratio: 1 / 1; /* 宽高比为 1:1 */
          &.add {
            width: 100%;
            // height: 100%;
            aspect-ratio: unset;
          }
        }
        i.el-icon-error {
          position: absolute;
          top: -6px;
          right: -6px;
          // padding: 3px;
          background: #fff;
          border-radius: 50%;
          // color: #fff;
          font-size: 18px;
        }
        &:last-child {
          border: 0;
        }
      }
    }
    .btn_row {
      margin-top: 20px;
      .el-button {
        width: 100%;
      }
    }
  }
}
.el-dialog {
  .img {
    font-size: 0;
    text-align: center;
    img {
      // max-width: 100%;
      // max-height: 70vh;
      // object-fit: contain;
      max-width: 80vw;
      max-height: 70vh;
      object-fit: contain;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/Workblank.vue